<template>
  <!--
      作者：kmdshop
      时间：2020-06-01
      描述：插件中心-回访-添加
    -->
    <el-dialog
    title="添加回访"
    :visible.sync="dialogVisible"
    @close="dialogFormVisible"
    :close-on-click-modal="false"
    :close-on-press-escape="false"
    width="50%"
  >

  <div class="product-add pb50">

    <el-form size="small" :model="form" ref="form" :rules="rules" label-width="100px">
      <div class="common-form">添加回访</div>
        <el-form-item label="选择订单" prop="name" >
        <div>{{ form.order_no }}</div>
      
        <el-button @click="chooseOrder" icon="el-icon-plus">选择订单</el-button>
      </el-form-item>

      <el-form-item label="回访名称" prop="name"><el-input v-model="form.name" placeholder="请输入回访名称" class="max-w460"></el-input></el-form-item>

      <el-form-item label="回访内容" prop="content">
        <el-input v-model="form.content" type="textarea" placeholder="请输入回访内容" class="max-w460"></el-input>
      </el-form-item>
      
      <el-form-item label="设定回访时间"  prop="time">
        <el-date-picker
                size="small"
                v-model="form.time"
                type="datetime"
                value-format="yyyy-MM-dd HH:mm"
              ></el-date-picker>

              <div>注：设置回访时间后，当达到回访时间，首页会弹出提示，进行回访记录</div>

      </el-form-item>
      
      <!-- <el-form-item label="回访状态" prop="status">

        <div >
            <el-radio-group v-model="form.status">
                <el-radio  :label="0" >待回访</el-radio>
                <el-radio  :label="1" >已完成</el-radio>
            </el-radio-group>
        </div>
      </el-form-item> -->

     

    
      <!--提交-->
      <div class="common-button-wrapper">
        <el-button size="small" type="info" @click="cancelFunc">取消</el-button>
        <el-button size="small" type="primary" @click="onSubmit" :loading="loading">提交</el-button>
      </div>
    </el-form>
  </div>
  <Order :is_open="is_order"   @close="closeOrderFunc"></Order>
</el-dialog>
  
</template>

<script>
import RvisitiApi from '@/api/rvisit.js';
import Order from '@/components/order/order'
export default {
  components: {
    Order
  },
  data() {
    return {

      /*form表单数据*/
      form: {
        name: '',
        content:"",//回访内容
        status:0,
        time:"",//回访时间
        order_no:"",
        order_id:""
      },
      loading: false,
      /*验证规则*/
      rules: {
        name: [{ required: true, message: '请输入回访名称', trigger: 'blur' }],
      },
      dialogVisible:false,
      is_order:false,
    };
  },
  created() {
    console.log(11111)
    this.dialogVisible = this.open_add;
  },
  props: ["open_add"],
  methods: {
     /*关闭弹窗*/
     dialogFormVisible(result) {
      this.$emit("close", { openDialog: false,"type":result });
    },
    cancelFunc(){//取消
      this.dialogFormVisible("error")
    },

    onSubmit() {
      let self = this;
      let form = self.form;
      self.$refs.form.validate(valid => {
        if (valid) {
          self.loading = true;
          RvisitiApi.add(form, true)
            .then(data => {
              self.loading = false;
              self.$message({
                message: data.msg,
                type: 'success'
              });
              self.dialogFormVisible("error")
            })
            .catch(error => {
              self.loading = false;
            });
        }
      });
    },

    /*取消添加，返回任务列表*/
    cancelFunc() {
      this.$emit("close", { openDialog: false,"type":"" });
    },
    closeOrderFunc(e){
      console.log("e",e)
        this.is_order = false
        this.form.order_no = e.params.order_no
        this.form.order_id = e.params.order_id
    },
    chooseOrder(){
      this.is_order = true
    }
  }
};
</script>

<style>
.edit_container {
  font-family: 'Avenir', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
}

.ql-editor {
  height: 400px;
}
</style>



// WEBPACK FOOTER //
// src/views/plus/rvisit/rvisit/part/add.vue